export const Stocks = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M9 14.2197H3.92C3.31 14.2197 2.75 14.5297 2.43 15.0497C2.11 15.5597 2.08 16.1697 2.34 16.7097C3.57 19.2297 5.79 21.2097 8.43 22.1397C8.61 22.1997 8.81 22.2397 9 22.2397C9.35 22.2397 9.7 22.1297 10 21.9197C10.47 21.5897 10.75 21.0497 10.75 20.4797L10.76 15.9797C10.76 15.5097 10.58 15.0697 10.25 14.7397C9.91 14.4097 9.47 14.2197 9 14.2197Z" />
    <path d="M22.48 9.6C21.36 4.68 17.05 1.25 12 1.25C6.95 1.25 2.64 4.68 1.52 9.6C1.4 10.12 1.52 10.65 1.86 11.07C2.2 11.49 2.7 11.73 3.24 11.73H20.77C21.31 11.73 21.81 11.49 22.15 11.07C22.48 10.65 22.6 10.11 22.48 9.6Z" />
    <path d="M20.06 14.2698L15 14.2598C14.53 14.2598 14.09 14.4398 13.76 14.7698C13.43 15.0998 13.25 15.5398 13.25 16.0098L13.26 20.4898C13.26 21.0598 13.54 21.5998 14.01 21.9298C14.31 22.1398 14.66 22.2498 15.01 22.2498C15.2 22.2498 15.39 22.2198 15.57 22.1498C18.19 21.2298 20.41 19.2598 21.64 16.7698C21.9 16.2398 21.87 15.6198 21.56 15.1198C21.23 14.5798 20.67 14.2698 20.06 14.2698Z" />
  </svg>
);
